module.exports = __webpack_public_path__ + "static/media/logo_huawei.7296b47d.png";